import { useAppSelector } from './useAppSelector'

export const useTranslations = () =>
  useAppSelector((state) => state.translation)
